import { toggleFixedBody } from '../helper';

const BODY = document.querySelector('body');
const LB_BUTTONS = document.querySelectorAll('div[data-open-lightbox]');

let focusedElBeforeOpen = null;

const trapFocus = (element) => {
	const focusableEls = element.querySelectorAll('button, img');
	const firstFocusableEl = focusableEls[0];
	const lastFocusableEl = focusableEls[focusableEls.length - 1];

	element.addEventListener('keydown', (e) => {
		const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) {
			if (document.activeElement === firstFocusableEl) {
				lastFocusableEl.focus();
				e.preventDefault();
			}
		} else if (document.activeElement === lastFocusableEl) {
			firstFocusableEl.focus();
			e.preventDefault();
		}
	});
};

const createLightBox = ({ id, imgSrc, alt, format }) => {
	const lightboxEl = document.createElement('div');
	lightboxEl.id = id;
	lightboxEl.className = 'lightbox';
	lightboxEl.setAttribute('data-lightbox', id);
	lightboxEl.setAttribute('aria-hidden', true);
	lightboxEl.innerHTML = `
        <div class="lightbox__inner">
			<button aria-label="Schließen" class="lightbox__close">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
					<g fill="none" stroke="#00848d" stroke-linecap="round" stroke-linejoin="round" stroke-width="6">
						<path d="m3.2 3.2 29.08 29.08"></path><path d="m32.28 3.2-29.08 29.08"></path>
					</g>
				</svg>
			</button>
			<img src="${imgSrc}" alt="${alt}" loading="lazy" data-format="${format}">
        </div>
    `;

	return lightboxEl;
};

const closeLightbox = () => {
	const lightbox = document.querySelector('body>.lightbox');

	if (lightbox) {
		BODY.removeChild(lightbox);
		focusedElBeforeOpen.focus();
	}
};

const addHandlerCloseDialog = () => {
	const lightbox = document.querySelector('body>.lightbox');

	lightbox.querySelector('.lightbox__close').addEventListener('click', () => closeLightbox(lightbox));
	window.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && lightbox) {
			closeLightbox(lightbox);
		}
	});
};

const toggleLightbox = (e) => {
	const el = e.currentTarget;
	const img = el.getElementsByTagName('img')[0];

	const props = {
		id: el.dataset.openLightbox,
		imgSrc: img.src,
		alt: img.alt,
		caption: el.dataset.caption,
		format: img.closest('figure').dataset.format,
	};

	const lb = createLightBox(props);
	BODY.appendChild(lb);

	lb.querySelector('.lightbox__close').focus();
	addHandlerCloseDialog();
	trapFocus(lb);

	focusedElBeforeOpen = el;
};

LB_BUTTONS.forEach((item) => {
	item.addEventListener('click', (event) => toggleLightbox(event));
});
